<div class="excel-container">
  <div class="filters-area">
    <span class="title-txt">Import File</span>
    <span class="closebtn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
</div>

  <div class="file-upload-area">
    <div class="input-file">
      <input type="file" id="fileInput" (change)="onFileChange($event)" multiple="false" accept=".xlsx, .xls"/>
    </div>
    <div *ngIf="sheetNames.length > 0" class="sheet-selctor">
      <select id="sheet-select" (change)="onSheetSelect($event.target)">
        <option [defaultSelected]="true">Select Sheet</option>
        <option *ngFor="let sheetName of sheetNames" [value]="sheetName">{{ sheetName }}</option>
      </select>
    </div>
  </div>
  

  <div class="table-container cls-table" *ngIf="data && data.length > 0">
    <!-- To show uploaded data in the table-->
     <div class="table-size">
      <table>
        <tr>
          <th></th>
          <th *ngFor="let key of columnList;let k = index">{{"col_"+(k+1)}}
            <div class="cls-btn" mat-raised-button (click)="onColDelete(key,k)">X</div>
          </th>
        </tr>
        <tr *ngFor="let item of data; let i=index">
          <th>{{"row_"+(i+1)}}
            <div class="cls-btn" mat-raised-button (click)="onRowDelete(i)">X</div>
            <!-- <span (click)="onRowDelete(i)">X</span> -->
          </th>
          <ng-container *ngFor="let key of columnList">
            <td *ngIf="item[key]">{{item[key] | decimalPipe}}</td>
            <td *ngIf="!item[key]"></td>
          </ng-container>
        </tr>
      </table>
      <div class="btn-list">
        <button class="red-white-btn btn" (click)="onRefineTable()">Refine Table</button>
      </div>
     </div>
    
  </div>

  <div class="refine-container cls-table" *ngIf="isREfineTableVisible">
    <!-- this table displays the refoined data after alteration-->
    <table>
      <tr *ngFor="let item of data; let i=index">
        <ng-container *ngFor="let key of combolist; let ind = index">
          <ng-container *ngIf="ind===0 || i ===0; else dataCond">
            <th *ngIf="item[key]">{{item[key] | decimalPipe}}</th>
            <th *ngIf="!item[key]"></th>
          </ng-container>
          <ng-template #dataCond>
              <td *ngIf="item[key]">{{item[key] | decimalPipe}}</td>
              <td *ngIf="!item[key]"></td>
          </ng-template>
        </ng-container>
      </tr>
    </table>
    <div class="btn-list">
      <button class="red-white-btn btn" color="primary" (click)="onTableToData()">Submit</button>
    </div>
  </div>

  <!-- this table displays data after pivot everything for reference-->
  <!-- <div class="pivot-table cls-table" *ngIf="pivotedData && pivotedData.length > 0">
    
    <table>
      <tr>
        <th *ngFor="let key of pivotTableHeader">{{key}}</th>
      </tr>
      <tr *ngFor="let item of pivotedData; let k=index">
        <ng-container *ngFor="let key of pivotTableHeader">
          <td *ngIf="item[key]">{{item[key] | decimalPipe}}</td>
          <td *ngIf="!item[key]" style="text-align: center;">-</td>
        </ng-container>
      </tr>
    </table>
  </div> -->

</div>